import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PendingApplicationsComponent } from './pending-applications.component';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ApiClient } from '../core/api-client.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PendingApplicationDetailsComponent } from './pending-application-details.component';
import { RouterModule } from '@angular/router';
import { EditCompanyInformationModalComponent } from './Modals/edit-company-information-modal.component';
import { EditLiaisonInformationModalComponent } from './Modals/edit-liaison-information-modal.component';
import { MbscModule, MbscOptionsService } from '@mobiscroll/angular';
import { EditMembershipInformationModalComponent } from './Modals/edit-membership-information-modal.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';



@NgModule({
    declarations: [

        PendingApplicationsComponent,
        PendingApplicationDetailsComponent,
        EditCompanyInformationModalComponent,
        EditLiaisonInformationModalComponent,
        EditMembershipInformationModalComponent
    ],
    imports: [
        CommonModule
        , FormsModule
        , NgbPaginationModule
        , RouterModule
        , ReactiveFormsModule
        , MbscModule
        , NgxMaskDirective
        , NgxMaskPipe
    ],
    providers: [ApiClient
        , MbscOptionsService
        , provideNgxMask()],
})
export class PendingApplicationsModule { }
